import { PassengerPagingDto } from '@/__generated';
import { formatDisplayDate } from '@/config';
import { getFullName } from '@/helpers/string';
import { useDebounce } from '@/hooks/useDebounce';
import { apiSdk } from '@/httpClient';
import { Select, SelectProps } from 'antd';
import React from 'react';

interface Props extends SelectProps<any> {
  ids?: string[];
}

export default function PassengerInput({ onChange, ids, ...props }: Props) {
  const [searchValue, setSearchValue] = React.useState<string>('');

  const [data, setData] = React.useState<PassengerPagingDto[]>([]);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [preUsers, setPreUsers] = React.useState<PassengerPagingDto[]>([]);

  React.useEffect(() => {
    if (ids?.length) {
      apiSdk.BookingPassengerService.getPassengers({ ids: ids, pageSize: ids.length }).then(res => setPreUsers(res.data || []));
    } else {
      setPreUsers([]);
    }
  }, [ids]);

  const getData = (searchText: string) => {
    setLoading(true);
    apiSdk.BookingPassengerService.getPassengers({
      searchText: searchText || undefined,
      pageSize: 100,
    })
      .then(res => {
        setData(res.data || []);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const searchValueDebounce = useDebounce(searchValue, 300);

  React.useEffect(() => {
    getData(searchValueDebounce);
  }, [searchValueDebounce]);

  const options: any[] = React.useMemo(() => {
    return (
      [...preUsers, ...data]?.map(c => {
        return {
          label: `${c.phoneCode || ''} ${c.phoneNumber || ''} ${getFullName(c.firstName, c.lastName)} ${c.emailAddress || ''} ${formatDisplayDate(
            c.dateOfBirth,
          )}`,
          value: c.id,
        };
      }) || []
    );
  }, [data, preUsers]);

  return (
    <Select
      {...props}
      loading={loading}
      showSearch
      onSearch={v => setSearchValue(v)}
      allowClear
      onChange={onChange}
      options={options}
      filterOption={false}
    ></Select>
  );
}
